import angular from 'angular';
import { StepPageComponent } from './step-page.component';
import { NextButtonModule } from '../next-button';
import { BackToDashboardButtonComponent } from '../back-to-dashboard-button';

export const StepPageModule = angular
  .module('upd.step-page', [
    BackToDashboardButtonComponent.name,
    NextButtonModule.name,
  ])
  .component('updStepPage', StepPageComponent);
